import { put, takeLatest, all, select } from 'redux-saga/effects';
import { API_URL } from 'containers/App/constants';
import { SAVE_DATA } from './constants';

import {
  makeSelectCarCreator,
} from './selectors';
import { requestSuccess } from './actions';
import { carLoaded } from '../CarSelector/actions';

import { getRequestHeadersAsLogged, responseHandler } from '../../utils/auth';


function* storeCar() {
  const car = yield select(makeSelectCarCreator());
  const requestURL = car.id ? `${API_URL}car/${car.id}` : `${API_URL}car`;

  try {
    const parameters = {
      method: car.id ? 'PUT' : 'POST',
      headers: getRequestHeadersAsLogged(),
      body: JSON.stringify(car),
    };
    const request = yield fetch(requestURL, parameters).then(response =>
      responseHandler(response)
    );
    yield put(requestSuccess(request.data));
    yield put(carLoaded(request.data));
  } catch (err) {
    // yield put(carError(err));
    console.log('request error', err);
  }
}

function* actionWatcher() {
  yield takeLatest(SAVE_DATA, storeCar);
}

export default function* carsData() {
  yield all([actionWatcher()]);
}
